/* Contrato da API do Portal do Responsável.

   As 4 rotas próprias do Responsável
   (Backend/app/Http/Controllers/Analytics/ResponsavelController.php,
   Backend/routes/Analytics/responsavel.php). Diferente da primeira versão
   deste arquivo, NÃO reaproveita as rotas geográficas de turma/escola/rede
   da Inteligência Educacional (turmaPainel, escolaKpis, kpisGlobal,
   turmaEngajamento) — o backend decidiu, de propósito, não estender aquele
   escopo geográfico ao Responsável (ver ResponsavelEscopoService: o recorte
   dele é relacional, "meus filhos em access_users_parents", não geográfico).
   Ele expôs em vez disso um endpoint de comparativo pronto, que já faz esse
   cálculo do lado do backend.

   Não existe rota de engajamento (score) para o Responsável — só filhos,
   execução, tempo online e comparativo de nota. Se isso vier a fazer falta,
   é pedido novo ao backend, não algo que dá para montar com o que existe. */

import { getAnalytics } from "./transport";

export const api = {
  /** Alunos vinculados ao responsável logado (resolvido pelo token, sem
      precisar informar o id dele). @returns {Array<{id,name,surname}>} */
  filhos: () => getAnalytics("/responsavel/filhos"),

  alunoExecucao: (alunoId, granularidade, ano, inicio, fim) =>
    getAnalytics(`/responsavel/aluno/${alunoId}/execucao`, {
      granularidade,
      ano,
      inicio,
      fim
    }),

  alunoTempoOnline: (alunoId, granularidade, ano, inicio, fim) =>
    getAnalytics(`/responsavel/aluno/${alunoId}/tempo-online`, {
      granularidade,
      ano,
      inicio,
      fim
    }),

  /** Nota do aluno x turma x escola x regional x rede. `null` quando o aluno
      ainda não apareceu no mart (404 do backend — não é erro de acesso, só
      ausência transitória de dado). */
  async alunoComparativo(alunoId, disciplinaId, ano, inicio, fim) {
    try {
      return await getAnalytics(`/responsavel/aluno/${alunoId}/comparativo`, {
        disciplina_id: disciplinaId,
        ano,
        inicio,
        fim
      });
    } catch (err) {
      if (err.status === 404) return null;
      throw err;
    }
  }
};
